import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Pagination, Input, Button } from "antd";
import moment from "moment";
import { useSearchEmployeeList } from "hooks/reports/reports";
import { exportCsvToXlsx } from "helpers/exportXlsx";
import { useDownloadCsv } from "hooks/csv/csv";
import Image from "helpers/Image";
import "../style.css";
import TableStateRow from "components/tableState";
import { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from "helpers/commonFunctions";

const SearchEmployee = () => {
  const [page, setPage] = useState(DEFAULT_PAGE_SIZE);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [initialValue, setInitialValue] = useState({
    searchKey: searchKey,
    pageNumber: pageNumber,
    pageSize: page,
  });
  const { mutate: getEmployee, data: getEmployeeDetails, isLoading: loading } =
    useSearchEmployeeList();
  const { refetch: refetchDownload, loading: csvLoading } = useDownloadCsv("reports/searchEmployee/csv", searchKey, pageNumber, page );

  const csvDownload = async () => {
    await refetchDownload().then((value) => {
      if(value.data) {
        exportCsvToXlsx(value.data, "Employee_Report", "Employees");
      }
    });
  };

  const onFetchEmployee = (values) => {
    const formData = JSON.stringify(values);
    getEmployee(formData, {
      onSuccess: (data) => {
        setEmployeeList(data?.data?.content);
      },
    });
  };

  const onChange = (page) => {
    initialValue.pageNumber = page - 1;
    setInitialValue(initialValue);
    setPageNumber(page - 1);
  };

  const onShowSizeChange = (current, pageSize) => {
    setPage(initialValue.pageSize = pageSize)
  }

  const searchHandler = (e) => {
    initialValue.searchKey = e.target.value;
    let data = { ...initialValue };
    data.searchKey = e.target.value;
    data.pageNumber = e.target.value !== "" ? 0 : initialValue.pageNumber;
    setInitialValue(data);
    setSearchKey(e.target.value);
  };

  useEffect(() => {
    onFetchEmployee(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, searchKey, page]);

  return (
    <Fragment>
      <Row className="common-heads" gutter={[12, 0]}>
        <Col md={17} className="title">
          <h1>Employee Search</h1>
          <p>Look up an employee and their last recorded location</p>
        </Col>
        <Col md={4}>
          <Input className="report-search" onChange={searchHandler} placeholder="Search" prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
        </Col>
        <Col md={3}>
          <Button onClick={csvDownload} loading={csvLoading} type="primary" className="csv">Download Excel</Button>
        </Col>
      </Row>
      <div className="common-table">
          <table>
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>Contractor</th>
                <th>Location Name</th>
                <th>Site Name</th>
                <th>Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <TableStateRow colSpan={5} loading />
              ) : employeeList == null || employeeList === undefined || employeeList?.length === 0 ? (
                <TableStateRow colSpan={5}>No employees found</TableStateRow>
              ) : employeeList?.map((item) => (
                  <tr>
                    <td>{item?.employeeName}</td>
                    <td>{item?.department}</td>
                    <td>{item?.locationName}</td>
                    <td>{item?.siteName}</td>
                    <td>{item?.dateAndTime && moment(item.dateAndTime, ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601]).isValid()
                      ? moment(item.dateAndTime, ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601]).format("DD-MM-YYYY HH:mm:ss")
                      : (item?.dateAndTime || "-")}</td>
                  </tr>
                ))}
            </tbody>
        </table>
      </div>
      <Row className="table-pagination">
        <Col md={12}>
          <h5>Showing {pageNumber === 0 ? 1 : (getEmployeeDetails?.data?.pageable?.offset + 1 || 0)} to {page === 0 ? (getEmployeeDetails?.data?.pageable?.offset + employeeList?.length || 0) : (getEmployeeDetails?.data?.pageable?.offset + getEmployeeDetails?.data?.numberOfElements || 0)} of {getEmployeeDetails?.data?.totalElements} entries</h5>
        </Col>
        <Col md={12} className="txt-right">
          {getEmployeeDetails?.data?.content?.length === 0 ? null : <Pagination pageSize={page} showSizeChanger pageSizeOptions={PAGE_SIZE_OPTIONS} onChange={onChange} current={pageNumber + 1} onShowSizeChange={onShowSizeChange} total={getEmployeeDetails?.data?.totalElements} />}
        </Col>
      </Row>
    </Fragment>
  );
};
export default SearchEmployee;
